module.exports = __webpack_public_path__ + "assets/img/btn-detail-35534fa0.png";